"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkXpeditionRequiredFiles = checkXpeditionRequiredFiles;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const PROJECT_EXT = '.prj';
const NETLIST_EXTS = ['.tel', '.qcv'];
const NETLIST_DISPLAY_EXT = '.tel or .qcv';
function missingFinding(requiredFileExt, noun, triggeringFile) {
    return {
        type: 'required-file-check',
        severity: sigma_engine_shared_1.BoundaryLevel.Error,
        message: `An Xpedition upload needs ${noun}, which is not in the uploaded files`,
        rule: 'xpedition-required-files',
        cadTool: 'xpedition',
        requiredFileExt,
        triggeringFile,
        errorType: sigma_engine_shared_1.FileCollectionValidationErrorType.MissingRequiredFile,
    };
}
function checkXpeditionRequiredFiles(context) {
    const paths = context.files.map((file) => file.relativePath.toLowerCase());
    const triggeringFile = context.fileDetails.find((detail) => detail.cadTool === 'xpedition')?.relativePath ??
        context.files[0]?.relativePath ??
        '';
    const findings = [];
    if (!paths.some((path) => path.endsWith(PROJECT_EXT))) {
        findings.push(missingFinding(PROJECT_EXT, 'a .prj project file', triggeringFile));
    }
    if (!paths.some((path) => NETLIST_EXTS.some((ext) => path.endsWith(ext)))) {
        findings.push(missingFinding(NETLIST_DISPLAY_EXT, 'a .tel or .qcv netlist', triggeringFile));
    }
    return findings;
}
//# sourceMappingURL=xpeditionRequiredFiles.js.map